import type { WebPropBasicConfig } from '@ocode/domain';

export const defaultBasicConfig: WebPropBasicConfig = {
  quickdraw: false,
};
